<template>
  <v-layout>
    <v-menu
      offset-y
      left
      origin="right top"
      z-index="99"
      transition="slide-y-transition"
      nudge-top="-10"
      content-class="businessprofiles-dropdown"
      :disabled="disableProfileSwitcher"
    >
      <template v-slot:activator="{ on }">
        <sidebar-item
          tile
          :size="24"
          :variant="2"
          :custom-classes="disableProfileSwitcher ? '' : 'cursor-pointer'"
          action
          :color="selectedBusinessProfile && selectedBusinessProfile.thumbnailLogo ? null: isForBizgain ? 'white' : 'primary'"
        >
          <template v-slot:avatar>
            <template v-if="selectedBusinessProfile">
              <v-img
                v-on="on"
                v-if="selectedBusinessProfile.thumbnailLogo"
                :src="logoStoragePath+selectedBusinessProfile.thumbnailLogo"
                contain
              />
              <template v-else>
                <span
                  v-on="on"
                  :class="{ 'primary--text' : isForBizgain }"
                >
                  {{ getInitials(selectedBusinessProfile.name) }}
                </span>
              </template>
            </template>
          </template>
          <template v-slot:content>
            <v-list-tile-title v-on="on" v-if="selectedBusinessProfile">
              {{ selectedBusinessProfile.name }}
            </v-list-tile-title>
          </template>
          <template v-slot:action>
            <template v-if="$vuetify.breakpoint.mdAndUp && !isOnboarding">
              <v-btn
                dark
                icon
                v-if="collapseSidebar"
                @click.prevent="toggleDrawer"
                class="mr-0"
                tabindex="-1"
              >
                <v-icon>chevron_right</v-icon>
              </v-btn>
              <v-btn
                dark
                icon
                v-if="!collapseSidebar"
                @click.prevent="toggleDrawer"
                class="mr-0"
                tabindex="-1"
              >
                <v-icon>chevron_left</v-icon>
              </v-btn>
            </template>
          </template>
        </sidebar-item>
      </template>
      <div class="dropdown-content">
        <div class="dropdown-top d-custom-flex justify-space-between primary">
          <span class="white--text fw-bold">
            {{ $t('message.changeProfile') }}
          </span>
        </div>
        <vue-perfect-scrollbar
          class="card-list dropdown-list"
          style="max-height:200px"
          :settings="settings"
        >
          <v-list dense v-if="otherBusinessProfiles.length>0">
            <template v-for="(businessProfile,index) in otherBusinessProfiles">
              <v-divider :key="`${businessProfile.id}-divider`" class="ma-0" v-if="index!=0" />
              <v-list-tile
                :key="businessProfile.id"
                class="pa-1 cursor-pointer"
                :class="{ 'light': businessProfile.id === -1 }"
                @click.exact="switchBusinessProfile(businessProfile)"
                @click.ctrl.exact="openBusinessProfile(businessProfile)"
              >
                <v-list-tile-avatar tile size="30" v-if="businessProfile.thumbnailLogo">
                  <!-- <img
                    :src="businessProfile.thumbnailLogo ? logoStoragePath+businessProfile.thumbnailLogo : ''"
                  > -->
                  <v-img
                    :src="businessProfile.thumbnailLogo ? logoStoragePath+businessProfile.thumbnailLogo : ''"
                    contain
                  />
                </v-list-tile-avatar>
                <template v-else>
                  <v-list-tile-avatar
                    tile
                    size="30"
                    color="primary"
                    v-if="getInitials(businessProfile.name)"
                  >
                    <span class="white--text">
                      {{ getInitials(businessProfile.name) }}
                    </span>
                  </v-list-tile-avatar>
                </template>
                <v-list-tile-content>
                  <v-list-tile-title v-html="businessProfile.name" />
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
          <v-divider class="ma-0" />
          <div class="d-custom-flex py-1 cursor-pointer dropdown-text" @click="createNewBp" v-if="allowCreate">
            <v-icon class="mx-4" color="primary">
              add_circle_outline
            </v-icon>
            <div class="dropdown-text pa-1">
              {{ $t('message.createNew') }}
            </div>
          </div>
        </vue-perfect-scrollbar>
      </div>
    </v-menu>
    <app-promise-dialog ref="productFeedConfirmation" />
  </v-layout>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import AppConfig from 'Constants/AppConfig';
import {
  VList,
  VListTile,
  VListTileAvatar,
  VListTileTitle,
  VListTileContent,
  VIcon,
  VDivider,
  VMenu,
  VBtn, VImg,
  VLayout
} from 'vuetify/lib';
import { OnboardingRoute } from '../../features/onboarding/constants';
import SidebarItem from 'Components/Sidebar/SidebarItem';
import AppPromiseDialog from 'Components/AppPromiseDialog/AppPromiseDialog';
import { Flavor } from '../../constants/storeTypes'
import { LocalBusinessRoute } from 'Features/localBusiness/router'
import { clearBizgainState } from 'Features/bizgainOnboarding/helpers/commonHelper';
import { RoimaticService } from 'AppServices/roimaticService';
import { Chat } from 'Mixins/chat';
export default {
  mixins: [Chat],
  data() {
    return {
      businessProfiles: [],
      logoStoragePath: AppConfig.logoStoragePath,
      menu: false,
      settings: {
        maxScrollbarLength: 160
      },
      productFeedPromptHeading: this.$t('message.productFeedPromptHeading'),
      productFeedPromptMessage: this.$t('message.productFeedPromptMessage'),
      flavour: Flavor
    };
  },
  components: {
    VList,
    VListTile,
    VListTileAvatar,
    VListTileTitle,
    VListTileContent,
    VIcon,
    VDivider,
    VMenu,
    VBtn, VImg,
    SidebarItem,
    AppPromiseDialog,
    VLayout
  },
  computed: {
    ...mapGetters([
      'user',
      'collapseSidebar',
      'isForCreativeBuilder',
      'businessProfileId',
      'roimaticConfiguration',
      'isProductConfigModified',
      'isHqFranchise',
      'isAutoFlavour',
      'portal',
      'isBrandPortal',
      'isForBizgain',
      'disableChatSupport',
      'freshChatRestoreId',
      'freshChatExternalId',
      'businessName'
    ]),
    otherBusinessProfiles() {
      let businessProfiles = !this.user || !this.user.businessProfiles
        ? []
        : this.selectedBusinessProfile
          ? this.user.businessProfiles.filter(
            businessProfile =>
              businessProfile.id !== this.selectedBusinessProfile.id
          )
          : this.user.businessProfiles;
      return businessProfiles.sort((a, b) => a.id - b.id);
    },
    selectedBusinessProfile() {
      return (
        this.user &&
        this.businessProfileId &&
        this.user.businessProfiles.find(bp => bp.id == this.businessProfileId)
      );
    },
    isOnboarding() {
      return this.$route.path.startsWith(OnboardingRoute.Signup.path);
    },
    allowCreate(){
      return !this.isAutoFlavour && !this.isBrandPortal && !this.isForBizgain;
    },
    disableProfileSwitcher(){
      return this.isForCreativeBuilder || (this.otherBusinessProfiles.length == 0 && !this.allowCreate)
    }
  },
  async created() {},
  methods: {
    ...mapActions([
      'setUser',
      'enableBpSwitcherMode',
      'setBusinessProfileId',
      'createTasks',
      'resetRoimaticCampaign',
      'setDraftCampaigns',
      'setRoimaticConfiguration'
    ]),
    async switchBusinessProfile(businessProfile) {
      if (this.$route.name == 'productFeed') {
        if (this.isProductConfigModified) {
          let result = await this.$refs.productFeedConfirmation.open(
            this.productFeedPromptHeading,
            this.productFeedPromptMessage,
            {
              persistent: true,
              threeButtonVaraint: true,
              saveAndContinueColor: 'primary',
              confirmColor: 'error',
              cancelColor: 'grey'
            }
          );
          if (result.saveAndContinue) {
            this.createTasks();
            this.swapBusinessProfile(businessProfile);
          } else if (result.continue) {
            this.swapBusinessProfile(businessProfile);
          }
        } else {
          this.swapBusinessProfile(businessProfile);
        }
      } else {
        clearBizgainState();
        this.resetRoimaticCampaign();
        this.setDraftCampaigns([]);
        if(!this.disableChatSupport){
          // Set new roimatic configuration
          this.setBusinessProfileId(businessProfile.id);
          let roimaticService = new RoimaticService(businessProfile.id);
          let response = await roimaticService.getRoimaticConfiguration();
          let roimaticConfiguration = response;
          await this.setRoimaticConfiguration(roimaticConfiguration);

          // Re-initialize freshchat widget
          await this.destroyChatPanel();
          localStorage.removeItem('freshChatRestoreId');
          localStorage.removeItem('freshChatExternalId');
          this.initializeChat(this.freshChatRestoreId, this.freshChatExternalId, this.$vuetify.theme, this.businessProfileId, this.businessName, this.user, false);
        }

        this.swapBusinessProfile(businessProfile);
      }
    },
    swapBusinessProfile(businessProfile, isCtrlClick = false) {
      this.enableBpSwitcherMode();
      let newRoute = {}
      if(this.isBrandPortal){
        if(businessProfile.id !== -1){
          newRoute.name = this.$route.name.replace('portal-', '');
          newRoute.params = {
            businessProfileId: businessProfile.id
          }
        } else {
          newRoute.name = `portal-${this.$route.name}`
        }
      }
      else {
        newRoute = {
          name: this.$route.name,
          params: { businessProfileId: businessProfile.id }
        }
      }
      if (isCtrlClick) {
        return newRoute
      } else {
        this.$router.push(newRoute);
      }
    },
    openBusinessProfile(businessProfile) {
      // This is added to handle ctrl + click to open another businessProfile in new tab.
      // This has to be done programtically because on the businessprofile switch we need to check product feed config has changed or not.
      // Because on route change Only the businessprofile params is change not the route and this cannot be handled using router gaurd.
      // TODO: Remove product feed logic in bp switcher
      let newRoute = this.$router.resolve(this.swapBusinessProfile(businessProfile, true));
      window.open(newRoute.href, '_blank');
    },
    createNewBp() {
      if (this.isForBizgain){
        this.$router.push({ name: LocalBusinessRoute.name });
      }
      else{
        this.$router.push({ name: OnboardingRoute.Signup.name });
      }
    },
    getInitials(name) {
      if (name) {
        var storeNames = name.split(' ');
        if (storeNames.length < 2) {
          return storeNames[0].slice(0, 2);
        } else {
          return storeNames
            .slice(0, 2)
            .map(n => n[0])
            .join('');
        }
      }
      return '';
    },
    toggleDrawer() {
      this.$store.dispatch('collapseSidebar', !this.collapseSidebar);
    }
  }
};
</script>
